var WorkWithUsDataTestId = /* @__PURE__ */ ((WorkWithUsDataTestId2) => {
  WorkWithUsDataTestId2["WORK_WITH_US_CONTAINER_OUR_OPPORTUNITIES"] = "work-with-us--container-our-opportunities";
  WorkWithUsDataTestId2["WORK_WITH_US_BUTTON_VIEW_OPPORTUNITIES"] = "work-with-us--button-view-opportunities";
  WorkWithUsDataTestId2["WORK_WITH_US_BUTTON_BECOME_OUR_PARTNER"] = "work-with-us--button-become-our-partner";
  WorkWithUsDataTestId2["WORK_WITH_US_BUTTON_CHECK_OPPORTUNITIES"] = "work-with-us--button-check-opportunities";
  return WorkWithUsDataTestId2;
})(WorkWithUsDataTestId || {});
export {
  WorkWithUsDataTestId
};
